import Swal from "sweetalert2";
import { types } from "../types/types";
import { fetchConToken, fetchSinToken } from "../helpers/fetch"


// Login and Register USER
export const startLogin = ( email, password ) =>{
    return async( dispatch ) => {

        const resp = await( fetchSinToken( 'auth', { email, password}, 'POST' ) );
        const body = await resp.json();

        if( body.ok ) {
            localStorage.setItem( 'token', body.token )
            localStorage.setItem( 'token-init-date', new Date().getTime() )
            // localStorage.setItem( 'cart', [] )
            dispatch( login({
                uid: body.uid,
                name: body.name,
                acces: body.acces,
                steam: body.steam,
                cart:[]
                })
            );
        } else {

            Swal.fire( 'error', body.msg, 'error' )

        };
    }

};

export const  startRegister = ( email , password , name ) =>{

    return async( dispatch ) =>{
        
        const acces = 'user'

        const resp = await( fetchSinToken( 'auth/register', {  email, password, name,acces}, 'POST' ) );
        const body = await resp.json();

        if( !localStorage.getItem( 'token' ) ){

            if( body.ok ){
                localStorage.setItem( 'token', body.token )
                localStorage.setItem( 'token-init-date', new Date().getTime() )
            // hace el login automatico despues del register
    
                dispatch( login({
                    uid: body.uid,
                    name: body.name,
                    acces: body.acces,
                    steam: body.steam,
                    })
                );
            }else {
    
                Swal.fire( 'Error', body.msg, 'error' )
    
            };

        }else{
            
                Swal.fire('Usuario creado')
        }
       

    }



};

export const startChecking = () =>{
    return async(dispatch)=>{
                          // fetchConToken ('auth/renew', {  }, 'GET' ) ---> no necesita argumentos y por defecto es get                 
        const resp = await( fetchConToken( 'auth/renew' ) );
        const body = await resp.json();
        
        if( body.ok ){
            localStorage.setItem( 'token', body.token )
            
            localStorage.setItem( 'token-init-date', new Date().getTime() )
            
             
            dispatch( login({
                uid: body.uid,
                name: body.name,
                acces: body.acces
            })
            );
          

        }else {
            dispatch( checkingFinish() )
        };




    }
}
const checkingFinish = () => ({ type: types.authChekingFinish })

export const login = ( user ) => ({
    type: types.authLogin,
    payload: user

});




export const startLogout = () => {
    return ( dispatch )=>{

        localStorage.clear();
        
        dispatch( logout() )
        window.location.reload()
    }
} 

const logout = () => ({ type: types.authLogOut })


// CRUD USERS ADMIN PANEL

export const userStartUpdate = ( user ) => {
    return async(dispatch) => {

       
        try {
            await fetchConToken(`auth/users/${ user.id }`,user,'PUT');
            


        } catch (error) {
            console.log(error)
        }

    }
}



export const cartAddNew = ( item ) =>({
    type: types.authCartAddNew,
    payload: item
})

export const cartDeleted = ( item ) =>({
    type: types.authCartDeleted,
    payload: item
})
export const cartClean = () =>({
    type: types.authCartClean
})


export const  startCartCheckout = ( cart ) =>{
  
        return async( dispatch )=>{

            try {
                
                const resp = await fetchConToken('checkout',cart,'POST');
                const body = await resp.json();
               
                
                console.log(body)
                if(body.ok){

                    
                    var script = document.createElement("script");
  
                    // The source domain must be completed according to the site for which you are integrating.
                    // For example: for Argentina ".com.ar" or for Brazil ".com.br".
                    script.src = "https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js";
                    // script.src = "https://sdk.mercadopago.com/js/v2";
                    script.type = "text/javascript";
                    script.dataset.preferenceId = body.id;
                    // script.dataset.elementsColor="#36f907"
                    script.dataset.elementsColorText="#f907f4"
                 
                  
                    
                    // console.log(script)
                    document.getElementById("page-content").innerHTML = "";
                    document.querySelector("#page-content").appendChild(script);
           
                    // createCheckoutButton(body.id);
                }else{
                   Swal.fire('Error',body.msg,'error')
                }
               
            } catch (error) {
                console.log(error)
            }
        }


   
};





